import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { beginLogin } from "@/lib/auth";

export function LoginPage() {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get("return_to") ?? "/";
    beginLogin(returnTo)
      .then((url) => {
        window.location.href = url;
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : String(e));
      });
  }, [location.search]);

  return (
    <div className="mx-auto mt-32 max-w-md px-4 text-center">
      {error ? (
        <div>
          <h1 className="text-xl font-semibold text-red-500">Login failed</h1>
          <p className="mt-2 text-sm text-neutral-500">{error}</p>
        </div>
      ) : (
        <>
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-900" />
          <p className="mt-4 text-sm text-neutral-500">
            Redirecting to AppSumo SSO…
          </p>
        </>
      )}
    </div>
  );
}
